import classNames from 'classnames';

export type SettingsDeviceType = 'audioInput' | 'audioOutput' | 'video';

/** Pattern to detect Bluetooth/wireless device labels for icon selection */
export const WIRELESS_DEVICE_PATTERN =
  /airpods|bt|bluetooth|beats|sony\stw[hf]-?|bose|jbl|jabra|plantronics|poly\s|sennheiser|buds|soundcore|anker|edifier|skullcandy|powerbeats/;

export const filterDevicesByKind = (devices: MediaDeviceInfo[], kind: MediaDeviceKind) =>
  devices.filter(
    (device) => device.kind === kind && device.deviceId && device.deviceId !== 'default'
  );

export const pointClassName = (volume: number, size: number) =>
  classNames('leading-2 text-sm transition-all', volume > size ? 'text-blue' : 'text-black/10');

export const getDeviceIcon = (
  device: MediaDeviceInfo,
  type: SettingsDeviceType
): 'video' | 'bluetooth' | 'microphone' | 'sound-on-filled' => {
  if (type === 'video') return 'video';
  if (WIRELESS_DEVICE_PATTERN.test(device.label.toLowerCase())) return 'bluetooth';
  return type === 'audioInput' ? 'microphone' : 'sound-on-filled';
};
